"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExerciseDefinitionMapper = void 0;
class ExerciseDefinitionMapper {
    mapFromGenerated(generated) {
        return generated;
    }
    mapToGenerated(exerciseResult) {
        return exerciseResult;
    }
}
exports.ExerciseDefinitionMapper = ExerciseDefinitionMapper;
//# sourceMappingURL=exercise-definition.mapper.js.map